{
  "links" : {
    "triggerLinksDescription" : "Link di attivazione Abilita Tu a inserire collegamenti Interno SMS e Gmail, che Abilita Tu a tracciare attività specifiche dei clienti e trigger occorrenze in base ad Attivo Quando si fa clic sul Link .",
    "enterName" : "Inserisci nome",
    "enterLinkURL" : "Inserisci URL del link",
    "save" : "Archivia",
    "cancel" : "Annulla",
    "delete" : "Elimina",
    "aboutToDeleteLink" : "`Tu're do per eliminare il Link trigger ${deleteRowName} . Il Link Eliminato non può essere ripristinato, ma sei sicuro che vuoi continuare?`",
    "noTriggerLinksFound" : "Nessun Link di attivazione trovato",
    "getStartedByAddingNewTriggerLinks" : "Inizia tramite l'aggiunta del Nuovo Link di attivazione",
    "newTriggerLink" : "Nuovo Linktrigger",
    "searchNoMatch" : "La tua ricerca non ha trovato alcun Link trigger .",
    "link" : "Link",
    "addLink" : "Aggiungi Link",
    "linkURL" : "URL del link",
    "name" : "Nome",
    "pleaseEnterNonEmptyLinkName" : "Inserisci un nome Link non vuoto",
    "pleaseEnterURL" : "Si prega di inserire l'URL",
    "actions" : "attività",
    "linkKey" : "Chiave Link",
    "keyCopied" : "Chiave Copiato"
  }
}
